import { type ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

export type MenuItemRightIconProps = {
  children: ReactNode;
};

export const MenuItemRightIcon = ({
  children,
}: MenuItemRightIconProps): ReactNode => {
  const { classes } = useStyles();
  if (!children) return null;
  return (
    <div className={classes.root} data-menu-trailing="icon" role="presentation">
      {children}
    </div>
  );
};

MenuItemRightIcon.displayName = 'BaseMenuItem.RightIcon';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
  },
}));
